const actions = {
  SET_STATE: 'dashboard/SET_STATE',
  GET_USER_STATS: 'dashboard/GET_USER_STATS',
  GET_BUSINESS_STATS: 'dashboard/GET_BUSINESS_STATS',
  GET_WALLET_STATISTICS : 'dashboard/GET_WALLET_STATISTICS'
}

export default actions
